import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import "../index.css";
import axios from 'axios';
import { FaTag } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';

function DayModule() {
    const location = useLocation();
    const navigate = useNavigate();
    const { Translate } = useContext(ProductContext);

    const  {Day_Name,examTypes, exams, selectedExamId, unique_day_id } = location.state || {};

    const ModuleId = location.state?.ModuleId || localStorage.getItem("ModuleId");
    const resolvedUniqueDayId = unique_day_id || ModuleId;

const examId = location.state?.examId || localStorage.getItem("examId");

const ModuleNameName = location.state?.ModuleNameName || localStorage.getItem("ModuleNameName");


    const [marker, setMarker] = useState([]);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [activePage, setActivePage] = useState("");
    const [LearningMethod, setLearningMethod] = useState();
    const [activeItem, setActiveItem] = useState(null);
    const authToken = localStorage.getItem("AuthToken");
    

    console.log("exams Day ", exams );
  console.log("examTypes Day", examTypes)

    console.log("selectedExamId:", selectedExamId);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!authToken) {
                    console.error('No Auth Token found');
                    navigate('/login');
                    return;
                }

                const response = await axios.get(
                    `https://api.japaking.online/api/learning-method/${ModuleId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                if (response?.data?.message) {
                    setLearningMethod(response?.data?.message);
                } else {
                    console.warn("No message found in the API response.");
                }
            } catch (err) {
                console.error('API error:', err);
                if (err.response && err.response.status === 401) {
                    navigate('/login');
                }
            }
        };

        fetchData();
    }, [ModuleId, authToken, navigate]);

    const getDayMarker = useCallback(async () => {
        try {
            const response = await fetch(
                `https://api.japaking.online/api/user-visits/visited-status?id=${ModuleId}&examId=${examId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error: ${response?.status}`);
            }

            const data = await response.json();
            const idArray = data?.map(item => item?.learning_method_id).filter(id => id !== null);
            const uniqueIdArray = [...new Set(idArray)];
            setMarker(uniqueIdArray);
        } catch (error) {
            console.log("Error getting marker IDs:", error);
        }
    }, [authToken, ModuleId, examId]);

    useEffect(() => {
        getDayMarker();
    }, [getDayMarker]);

    const dayMarker = useCallback(async (id, callback) => {
        try {
            const response = await fetch(
                `https://api.japaking.online/api/user-visits/log-visit`,
                {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: JSON.stringify({
                        id: ModuleId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: id,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const responseData = await response.json();
            console.log("Day marker response: " + JSON.stringify(responseData));

            if (callback) {
                callback(responseData);
            }
        } catch (error) {
            console.log("Error posting day marker:", error);
        }
    }, [ModuleId, resolvedUniqueDayId, authToken]);

    useEffect(() => {
        setActiveItem(null);
    }, []);

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon
                                onClick={() => navigate("/learning-journey", {
                                    state: {
                                        examId,
                                        examTypes,
                                        selectedExamId,
                                    }
                                })}
                                className='icon_1'
                            />
                            <h2>{ModuleNameName}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>
<div className="container">
            <div className="main-div-section">
                <div className="content-box-day-module">
                    
                        <div className="row">
                            <div className="col-md-12">
                                <div className="daymodule-image">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/learning5.png`}
                                        alt="Japan"
                                    />
                                </div>
                                {LearningMethod?.learningMethods?.map((learningmethod1, index) => (
                                    <div className="row" key={index}>
                                        <div className="button-wrapper">
                                            <button
                                                className='learn-script-content-day-module'
                                                onClick={() => {
                                                    const markerId = learningmethod1?.learning_method_id;
                                                    dayMarker(markerId);
                                                    setActiveItem(learningmethod1?.learning_method_id);
                                                    localStorage.setItem("ModuleNameName", ModuleNameName);

                                                    navigate("/learn-script", {
                                                        state: {
                                                            LearningId: learningmethod1?.learning_method_id,
                                                            // methodType: learningmethod1?.method_type,
                                                            dayId: learningmethod1?.day_id,
                                                            unique_day_id: ModuleId,
                                                            dayName: Day_Name,
                                                            day_learning_method_id: learningmethod1?.day_learning_method_id,
                                                            examId,
                                                            ModuleId,
                                                            examTypes,
                                                            selectedExamId,
                                                        },
                                                    });
                                                }}
                                            >
                                                <div className="module-text-learn-script">
                                                    <div className="module-text-learn-script22">
                                                        {marker?.includes(learningmethod1?.learning_method_id) && (
                                                            <div
                                                                style={{
                                                                    textAlign: "left",
                                                                    width: '100%',
                                                                    display: 'inline-block',
                                                                    paddingBottom: 10
                                                                }}
                                                            >
                                                                <FaTag color="#ffc0cb" size={20} style={{ display: 'inline-block' }} />
                                                                <p
                                                                    style={{
                                                                        color: "#ffc0cb",
                                                                        fontSize: 14,
                                                                        paddingLeft: 15,
                                                                        fontWeight: '600',
                                                                        display: 'inline-block'
                                                                    }}
                                                                >
                                                                    {Translate?.message?.data?.Learned || "Learned"}
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <h2>{learningmethod1?.method_type}</h2>
                                                    <p>{learningmethod1?.desc}</p>
                                                </div>
                                                <img
                                                    src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : learningmethod1?.image_url}
                                                    onLoad={() => setIsLoadingImage(false)}
                                                    onError={() => setIsLoadingImage(false)}
                                                    alt={`${learningmethod1?.method_type} Icon`}
                                                    className="daymodule-icon"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                {!LearningMethod && <p>Loading...</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <Footer />
    </div>
  );
}

export default DayModule;
